import type { Filters } from './types';

const STORAGE_PREFIX = 'apex.tasks.filters';

export function filtersStorageKey(userId: number, parent?: { type: string; id: number }): string {
  const scope = parent ? `${parent.type}-${parent.id}` : 'all';

  return `${STORAGE_PREFIX}.u${userId}.${scope}`;
}

export function loadStoredFilters(key: string): Partial<Filters> | null {
  try {
    const stored = window.localStorage.getItem(key);
    if (!stored) return null;

    const parsed = JSON.parse(stored);
    if (parsed && typeof parsed === 'object') return parsed as Partial<Filters>;
  } catch {
    return null;
  }

  return null;
}

export function saveStoredFilters(key: string, filters: Filters): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(filters));
  } catch {
    // fail gracefully if localStorage is not available / full
  }
}
